<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Sub Grupos"
        p-read-link="subGroup.read.one"
        p-create-link="subGroup.create"
        p-name="subGroup"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwSubGroupRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'descrição',
                value: 'descricao'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>